import { defineRule } from 'vee-validate'

defineRule('bool', (value, params, { field }) => {
  if (typeof value === 'boolean') {
    return true
  }
  return `The ${field} value is not a boolean.`
})
